<div class="loader-overlay" [ngStyle]="{'backgroundColor': backGroundColor}">
    <div class="loader-wrapper">
        <div class="custom-spinner">
            <mat-spinner [diameter]="130" [strokeWidth]="5"class="my-spinner"></mat-spinner>
        </div>
        <img class="logo" src="../../../../assets/img/logos/lex-logo-blue.svg" alt="" />
    </div>
</div>